const createKeyViewerApi = ({ keyViewer, logger }) => ({
    keyViewer: {
        async getEncodedPrivateKey(...args) {
            logger.warn('keyViewer.getEncodedPrivateKey is deprecated, use keyViewer.getEncodedPrivateKeys instead');
            const [{ privateKey }] = await keyViewer.getEncodedPrivateKeys(...args);
            return privateKey;
        },
        getEncodedPrivateKeys: keyViewer.getEncodedPrivateKeys,
    },
});
const keyViewerApiDefinition = {
    id: 'keyViewerApi',
    type: 'api',
    factory: createKeyViewerApi,
    dependencies: ['keyViewer', 'logger'],
};
export default keyViewerApiDefinition;
